import { createPath } from "@odata/BindingContext";
import {
    EntitySetName,
    EntityTypeName,
    GovernmentInstitutionEntity,
    PrGovernmentInstitutionContactEntity,
    PrGovernmentInstitutionDetailEntity
} from "@odata/GeneratedEntityTypes";
import i18next from "i18next";

import { IFormDef } from "../../../views/formView/Form";
import { setDefByEntityType } from "../../getDefByEntityType";
import { IDefinition, IGetDefinition } from "../../PageUtils";
import {
    getContactsRowsDef,
    GOVERNMENT_INSTITUTIONS,
    governmentInstitutionLocalPath
} from "./GovernmentInstitution.utils";


export const getDefinitions: IGetDefinition = (): IDefinition => {
    const entitySet = EntitySetName.PrPayrollSettings;
    const form: IFormDef = {
        id: `${EntityTypeName.PrPayrollSetting}Form`,
        title: i18next.t("GovernmentInstitution:Title"),
        translationFiles: getDefinitions.translationFiles,
        fieldDefinition: {
            ...getContactsRowsDef()
        },
        groups: [
            ...GOVERNMENT_INSTITUTIONS.reduce((defs, institution) => {
                return [
                    ...defs,
                    {
                        id: institution,
                        title: i18next.t(`GovernmentInstitution:${institution}`),
                        rows: [[{ id: createPath(institution, governmentInstitutionLocalPath) },
                            { id: createPath(institution, governmentInstitutionLocalPath, GovernmentInstitutionEntity.Street) },
                            { id: createPath(institution, governmentInstitutionLocalPath, GovernmentInstitutionEntity.City) },
                            { id: createPath(institution, governmentInstitutionLocalPath, GovernmentInstitutionEntity.PostalCode) },
                            { id: createPath(institution, governmentInstitutionLocalPath, GovernmentInstitutionEntity.Country) },
                            { id: createPath(institution, governmentInstitutionLocalPath, GovernmentInstitutionEntity.DataBoxId) },
                            // { id: createPath(institution, PrGovernmentInstitutionDetailEntity.AccountNumber) }
                        ]]
                    },
                    {
                        id: `${institution}PaymentDetails`,
                        rows: [[
                            { id: createPath(institution, PrGovernmentInstitutionDetailEntity.SymbolVariable) },
                            { id: createPath(institution, PrGovernmentInstitutionDetailEntity.SymbolSpecific) },
                            { id: createPath(institution, PrGovernmentInstitutionDetailEntity.SymbolConstant) },
                            { id: createPath(institution, PrGovernmentInstitutionDetailEntity.RemittanceInformation) }
                        ]]
                    },
                    {
                        id: `${institution}Contacts`,
                        rows: [[
                            { id: createPath(institution, PrGovernmentInstitutionDetailEntity.Contact, PrGovernmentInstitutionContactEntity.FirstName) },
                            { id: createPath(institution, PrGovernmentInstitutionDetailEntity.Contact, PrGovernmentInstitutionContactEntity.LastName) },
                            { id: createPath(institution, PrGovernmentInstitutionDetailEntity.Contact, PrGovernmentInstitutionContactEntity.Email) },
                            { id: createPath(institution, PrGovernmentInstitutionDetailEntity.Contact, PrGovernmentInstitutionContactEntity.PhoneNumber) }
                        ]]
                    }];
            }, [])
        ],
        additionalProperties: []
    };

    return {
        entitySet,
        form
    };
};

getDefinitions.translationFiles = ["GovernmentInstitution"];
setDefByEntityType(EntityTypeName.PrPayrollSetting, getDefinitions);